import { render, staticRenderFns } from "./RecentlyPlayedGames.vue?vue&type=template&id=18a37e84&scoped=true&"
import script from "./RecentlyPlayedGames.vue?vue&type=script&lang=js&"
export * from "./RecentlyPlayedGames.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyPlayedGames.vue?vue&type=style&index=0&id=18a37e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/pongping/htdocs/ufs896@vip/mexicano/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a37e84",
  null
  
)

export default component.exports